import { User } from './auth/user.model';
import { Person } from './person.model';
import { Permissions } from './permission.model';
import { CostType } from './cost-types.model';

export class Employee {
    constructor(
        public id?: number,
        public user?: User,
        public person?: Person,
        public permissions?: Permissions[],
        public costTypesPossibleToMeritoricalApprove?: CostType[],
        public costTypesPossibleToRegister?: CostType[],
        public hasStaticAdvance?: boolean,
        public position?: string,
        public department?: string
    ) { }

    static adapt(item): Employee {
        if (item) {
            return new Employee(
                item.id,
                item.user ? User.adapt(item.user) : null,
                item.person ? Person.adapt(item.person) : null,
                item.permissions,
                item.costTypesPossibleToMeritoricalApprove ? item.costTypesPossibleToMeritoricalApprove.map(CostType.adapt) : [],
                item.costTypesPossibleToRegister ? item.costTypesPossibleToRegister.map(CostType.adapt) : [],
                item.hasStaticAdvance,
                item.position,
                item.department
            );
        } else {
            return null;
        }
    }
}
